let dd = require("ES/lib/dd");
let Modal = require("ES/widgets/Modal");

module.exports = dd.createClass({
	render(){
		let {message, onClose} = this.props;
		return Modal({
				title: "",
				onClose
			},
			dd.p(null,
				message
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/details/ParentChildControls/ParentChildMessageModal.js